import React from "react";
import useWindowDimensions from "../../../get-diemensions/UseWindowDiemensions";
import { colors } from "../../../themes/Colors";
import { BaseButton, GhostButton } from "../../../components/atoms";
import { useNavigate } from "react-router-dom";

const MainBanner = ({ onSignUpClick }) => {
  const { width, height } = useWindowDimensions();
  const navigate = useNavigate();
  return (
    <div
      className="banner"
      style={{
        maxWidth: 1440,
        width: width,
        minheight: 720,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
      }}
    >
      <img
        alt="banner image"
        src={require("../../../images/landing/mainLandingImage.png")}
        style={{
          maxWidth: 1440,
          width: width > 599 ? width : null,
          height: width > 599 ? null : 600,
        }}
      />
      <div
        style={{
          position: "absolute",
          //   bottom: 0,
          width: width - 100,
          maxWidth: 1260,
          height: width <= 900 ? (width > 599 ? "140%" : "80%") : "80%",

          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <div style={{ height: "70%", maxWidth: 400 }}>
          <h1
            style={{
              fontSize: 40,
              color: colors.white,
              width: "100%",
              textAlign: "right",
              fontWeight: "bold",
            }}
          >
            Recognizing all medicinal practices
          </h1>
          <p
            style={{
              color: colors.white,
              width: "100%",
              textAlign: "right",
              fontWeight: "bold",
            }}
          >
            delivered within a controlled pharmaceutical ecosystem.
          </p>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
          >
            <BaseButton
              label={"See Locations"}
              width={140}
              marginRight={20}
              onClick={() => navigate("/pharmacies")}
            />{" "}
            <BaseButton label={"Sign up"} width={120} onClick={onSignUpClick} />
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              marginTop: 10,
              marginBottom: 10,
            }}
          >
            <GhostButton
              label={"learn more about medical options"}
              width={280}
              borderColor={colors.white}
              href={
                "https://www.google.com/search?q=sahpra&sca_esv=5ea039d3f5929d6f&rlz=1C5CHFA_enZA1125ZA1125&sxsrf=AHTn8zqv39llh0lfhJZ6pfisHQDHgpI0AQ%3A1747477514356&ei=CmQoaPG_FaGWxc8P8dyI2Ak&ved=0ahUKEwjx7PuDpaqNAxUhS_EDHXEuApsQ4dUDCBA&uact=5&oq=sahpra&gs_lp=Egxnd3Mtd2l6LXNlcnAiBnNhaHByYTIKECMYgAQYJxiKBTIKEAAYgAQYQxiKBTIKEAAYgAQYFBiHAjILEAAYgAQYkQIYigUyBRAAGIAEMgoQABiABBhDGIoFMgUQABiABDIFEAAYgAQyBRAAGIAEMgoQABiABBhDGIoFSKcZUMEOWLMXcAF4AZABAJgBrwKgAZ4LqgEFMi00LjG4AQPIAQD4AQGYAgagAsQLwgIKEAAYsAMY1gQYR8ICBBAjGCfCAg0QLhiABBhDGNQCGIoFwgIREC4YgAQYkQIYxwEYigUYrwHCAgoQLhiABBhDGIoFwgINEC4YgAQYsQMYQxiKBcICEBAuGIAEGLEDGEMYgwEYigWYAwCIBgGQBgiSBwcxLjAuMy4yoAfDRbIHBTItMy4yuAe8C8IHAzItNsgHJA&sclient=gws-wiz-serp"
              }
            />
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
          >
            <div
              className=" identifier"
              style={{
                width: 250,
                maxWidth: 250,
                minWidth: 250,
                height: 54,
                minheight: 54,
                maxHeight: 54,
                borderRadius: 8,
                backgroundColor: colors.white,
                display: "flex",
                alignItems: "center",
                marginRight: 5,
              }}
            >
              <img
                alt="CUMCS Logo"
                src={require("../../../images/landing/CUMCS 1.png")}
              />
              <img
                alt="SAHPHRA Logo"
                src={require("../../../images/landing/image002 (1) 1.png")}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainBanner;
